class MscDcPackage {
  constructor(code, chineseName, englishName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const CODE_NAME = 'MscDcPackage'

export const MSC_PACKAGE_CONVENTIONAL = new MscDcPackage('C', 'Conventional', 'Conventional')
export const MSC_PACKAGE_IBC = new MscDcPackage('I', 'IBC', 'IBC')
export const MSC_PACKAGE_LARGE = new MscDcPackage('L', 'Large', 'Large')
export const MSC_PACKAGE_TANK = new MscDcPackage('T', 'Tank', 'Tank')
export const MSC_PACKAGE = [MSC_PACKAGE_CONVENTIONAL, MSC_PACKAGE_IBC, MSC_PACKAGE_LARGE, MSC_PACKAGE_TANK]
